// ── Pierwsze Piętro (34 images) ──────────────────────────
import pp1 from "images/Gallery/PierwszePietro/1.webp";
import pp2 from "images/Gallery/PierwszePietro/2.webp";
import pp3 from "images/Gallery/PierwszePietro/3.webp";
import pp4 from "images/Gallery/PierwszePietro/4.webp";
import pp5 from "images/Gallery/PierwszePietro/5.webp";
import pp6 from "images/Gallery/PierwszePietro/6.webp";
import pp7 from "images/Gallery/PierwszePietro/7.webp";
import pp8 from "images/Gallery/PierwszePietro/8.webp";
import pp9 from "images/Gallery/PierwszePietro/9.webp";
import pp10 from "images/Gallery/PierwszePietro/10.webp";
import pp11 from "images/Gallery/PierwszePietro/11.webp";
import pp12 from "images/Gallery/PierwszePietro/12.webp";
import pp13 from "images/Gallery/PierwszePietro/13.webp";
import pp14 from "images/Gallery/PierwszePietro/14.webp";
import pp15 from "images/Gallery/PierwszePietro/15.webp";
import pp16 from "images/Gallery/PierwszePietro/16.webp";
import pp17 from "images/Gallery/PierwszePietro/17.webp";
import pp18 from "images/Gallery/PierwszePietro/18.webp";
import pp19 from "images/Gallery/PierwszePietro/19.webp";
import pp20 from "images/Gallery/PierwszePietro/20.webp";
import pp21 from "images/Gallery/PierwszePietro/21.webp";
import pp22 from "images/Gallery/PierwszePietro/22.webp";
import pp23 from "images/Gallery/PierwszePietro/23.webp";
import pp24 from "images/Gallery/PierwszePietro/24.webp";
import pp25 from "images/Gallery/PierwszePietro/25.webp";
import pp26 from "images/Gallery/PierwszePietro/26.webp";
import pp27 from "images/Gallery/PierwszePietro/27.webp";
import pp28 from "images/Gallery/PierwszePietro/28.webp";
import pp29 from "images/Gallery/PierwszePietro/29.webp";
import pp30 from "images/Gallery/PierwszePietro/30.webp";
import pp31 from "images/Gallery/PierwszePietro/31.webp";
import pp32 from "images/Gallery/PierwszePietro/32.webp";
import pp33 from "images/Gallery/PierwszePietro/33.webp";
import pp34 from "images/Gallery/PierwszePietro/34.webp";
import pp35 from "images/Gallery/PierwszePietro/35.webp";
import pp36 from "images/Gallery/PierwszePietro/36.webp";
import pp37 from "images/Gallery/PierwszePietro/37.webp";
import pp38 from "images/Gallery/PierwszePietro/38.webp";

// ── Drugie Piętro (35 images) ────────────────────────────
import dp1 from "images/Gallery/DrugiePietro/1.webp";
import dp2 from "images/Gallery/DrugiePietro/2.webp";
import dp3 from "images/Gallery/DrugiePietro/3.webp";
import dp4 from "images/Gallery/DrugiePietro/4.webp";
import dp5 from "images/Gallery/DrugiePietro/5.webp";
import dp6 from "images/Gallery/DrugiePietro/6.webp";
import dp7 from "images/Gallery/DrugiePietro/7.webp";
import dp8 from "images/Gallery/DrugiePietro/8.webp";
import dp9 from "images/Gallery/DrugiePietro/9.webp";
import dp10 from "images/Gallery/DrugiePietro/10.webp";
import dp11 from "images/Gallery/DrugiePietro/11.webp";
import dp12 from "images/Gallery/DrugiePietro/12.webp";
import dp13 from "images/Gallery/DrugiePietro/13.webp";
import dp14 from "images/Gallery/DrugiePietro/14.webp";
import dp15 from "images/Gallery/DrugiePietro/15.webp";
import dp16 from "images/Gallery/DrugiePietro/16.webp";
import dp17 from "images/Gallery/DrugiePietro/17.webp";
import dp18 from "images/Gallery/DrugiePietro/18.webp";
import dp19 from "images/Gallery/DrugiePietro/19.webp";
import dp20 from "images/Gallery/DrugiePietro/20.webp";
import dp21 from "images/Gallery/DrugiePietro/21.webp";
import dp22 from "images/Gallery/DrugiePietro/22.webp";
import dp23 from "images/Gallery/DrugiePietro/23.webp";
import dp24 from "images/Gallery/DrugiePietro/24.webp";
import dp25 from "images/Gallery/DrugiePietro/25.webp";
import dp26 from "images/Gallery/DrugiePietro/26.webp";
import dp27 from "images/Gallery/DrugiePietro/27.webp";
import dp28 from "images/Gallery/DrugiePietro/28.webp";
import dp29 from "images/Gallery/DrugiePietro/29.webp";
import dp30 from "images/Gallery/DrugiePietro/30.webp";
import dp31 from "images/Gallery/DrugiePietro/31.webp";
import dp32 from "images/Gallery/DrugiePietro/32.webp";
import dp33 from "images/Gallery/DrugiePietro/33.webp";
import dp34 from "images/Gallery/DrugiePietro/34.webp";
import dp35 from "images/Gallery/DrugiePietro/35.webp";

// ── Szatnie (9 images) ────────────────────────────────────
import sz1 from "images/Gallery/Szatnie/1.webp";
import sz2 from "images/Gallery/Szatnie/2.webp";
import sz3 from "images/Gallery/Szatnie/3.webp";
import sz4 from "images/Gallery/Szatnie/4.webp";
import sz5 from "images/Gallery/Szatnie/5.webp";
import sz6 from "images/Gallery/Szatnie/6.webp";
import sz7 from "images/Gallery/Szatnie/7.webp";
import sz8 from "images/Gallery/Szatnie/8.webp";
import sz9 from "images/Gallery/Szatnie/9.webp";

// ── Wejście (1 image) ─────────────────────────────────────
import wej1 from "images/Gallery/Wejscie/1.webp";

// ── Zewnątrz (3 images) ───────────────────────────────────
import zew1 from "images/Gallery/Zewnatrz/1.webp";
import zew2 from "images/Gallery/Zewnatrz/2.webp";
import zew3 from "images/Gallery/Zewnatrz/3.webp";

import "./MainGallery.scss";
import Modal from "react-modal";
import { useState } from "react";
import GalleryImage from "pages/Components/GalleryImage/GalleryImage";

type SectionKey = "floor1" | "floor2" | "other";

interface IGallerySection {
  key: SectionKey;
  label: string;
  sublabel: string;
  description: string;
  images: { src: string; alt: string }[];
}

const gallerySections: IGallerySection[] = [
  {
    key: "floor1",
    label: "I Piętro",
    sublabel: "Pierwsze piętro",
    description:
      "Pierwsze piętro to rozległa strefa wolnych ciężarów z pełnym zestawem hantli od 1 do 55 kg, olimpijskimi sztangami z kolorowymi talerzami AXXA Poland oraz wieloma stanowiskami do ćwiczeń klatki piersiowej. Znajdziesz tu również zaawansowane maszyny wyciągowe z regulowanymi kablami, profesjonalne krzesła i ławki do ćwiczeń wielostawowych, a także duże lustra. Pierwsze piętro to także przestronna strefa rozciągania z matami, rollerami i akcesoriami do mobilności.",
    images: [
      { src: pp1, alt: "Centrum Siły — pierwsze piętro 1" },
      { src: pp2, alt: "Centrum Siły — pierwsze piętro 2" },
      { src: pp3, alt: "Centrum Siły — pierwsze piętro 3" },
      { src: pp4, alt: "Centrum Siły — pierwsze piętro 4" },
      { src: pp5, alt: "Centrum Siły — pierwsze piętro 5" },
      { src: pp6, alt: "Centrum Siły — pierwsze piętro 6" },
      { src: pp7, alt: "Centrum Siły — pierwsze piętro 7" },
      { src: pp8, alt: "Centrum Siły — pierwsze piętro 8" },
      { src: pp9, alt: "Centrum Siły — pierwsze piętro 9" },
      { src: pp10, alt: "Centrum Siły — pierwsze piętro 10" },
      { src: pp11, alt: "Centrum Siły — pierwsze piętro 11" },
      { src: pp12, alt: "Centrum Siły — pierwsze piętro 12" },
      { src: pp13, alt: "Centrum Siły — pierwsze piętro 13" },
      { src: pp14, alt: "Centrum Siły — pierwsze piętro 14" },
      { src: pp15, alt: "Centrum Siły — pierwsze piętro 15" },
      { src: pp16, alt: "Centrum Siły — pierwsze piętro 16" },
      { src: pp17, alt: "Centrum Siły — pierwsze piętro 17" },
      { src: pp18, alt: "Centrum Siły — pierwsze piętro 18" },
      { src: pp19, alt: "Centrum Siły — pierwsze piętro 19" },
      { src: pp20, alt: "Centrum Siły — pierwsze piętro 20" },
      { src: pp21, alt: "Centrum Siły — pierwsze piętro 21" },
      { src: pp22, alt: "Centrum Siły — pierwsze piętro 22" },
      { src: pp23, alt: "Centrum Siły — pierwsze piętro 23" },
      { src: pp24, alt: "Centrum Siły — pierwsze piętro 24" },
      { src: pp25, alt: "Centrum Siły — pierwsze piętro 25" },
      { src: pp26, alt: "Centrum Siły — pierwsze piętro 26" },
      { src: pp27, alt: "Centrum Siły — pierwsze piętro 27" },
      { src: pp28, alt: "Centrum Siły — pierwsze piętro 28" },
      { src: pp29, alt: "Centrum Siły — pierwsze piętro 29" },
      { src: pp30, alt: "Centrum Siły — pierwsze piętro 30" },
      { src: pp31, alt: "Centrum Siły — pierwsze piętro 31" },
      { src: pp32, alt: "Centrum Siły — pierwsze piętro 32" },
      { src: pp33, alt: "Centrum Siły — pierwsze piętro 33" },
      { src: pp34, alt: "Centrum Siły — pierwsze piętro 34" },
      { src: pp35, alt: "Centrum Siły — pierwsze piętro 35" },
      { src: pp36, alt: "Centrum Siły — pierwsze piętro 36" },
      { src: pp37, alt: "Centrum Siły — pierwsze piętro 37" },
      { src: pp38, alt: "Centrum Siły — pierwsze piętro 38" },
    ],
  },
  {
    key: "floor2",
    label: "II Piętro",
    sublabel: "Drugie piętro",
    description:
      "Drugie piętro siłowni zachwyca bogatym wyposażeniem w maszyny siłowe. Znajdziesz tu nowoczesne urządzenia do ćwiczeń górnych partii ciała, specjalistyczne maszyny na nogi i plecy. Znajduje sie tu także strefa kardio zawierająca bieżnie, rowery stacjonarne i eliptyczne.",
    images: [
      { src: dp1, alt: "Centrum Siły — drugie piętro 1" },
      { src: dp2, alt: "Centrum Siły — drugie piętro 2" },
      { src: dp3, alt: "Centrum Siły — drugie piętro 3" },
      { src: dp4, alt: "Centrum Siły — drugie piętro 4" },
      { src: dp5, alt: "Centrum Siły — drugie piętro 5" },
      { src: dp6, alt: "Centrum Siły — drugie piętro 6" },
      { src: dp7, alt: "Centrum Siły — drugie piętro 7" },
      { src: dp8, alt: "Centrum Siły — drugie piętro 8" },
      { src: dp9, alt: "Centrum Siły — drugie piętro 9" },
      { src: dp10, alt: "Centrum Siły — drugie piętro 10" },
      { src: dp11, alt: "Centrum Siły — drugie piętro 11" },
      { src: dp12, alt: "Centrum Siły — drugie piętro 12" },
      { src: dp13, alt: "Centrum Siły — drugie piętro 13" },
      { src: dp14, alt: "Centrum Siły — drugie piętro 14" },
      { src: dp15, alt: "Centrum Siły — drugie piętro 15" },
      { src: dp16, alt: "Centrum Siły — drugie piętro 16" },
      { src: dp17, alt: "Centrum Siły — drugie piętro 17" },
      { src: dp18, alt: "Centrum Siły — drugie piętro 18" },
      { src: dp19, alt: "Centrum Siły — drugie piętro 19" },
      { src: dp20, alt: "Centrum Siły — drugie piętro 20" },
      { src: dp21, alt: "Centrum Siły — drugie piętro 21" },
      { src: dp22, alt: "Centrum Siły — drugie piętro 22" },
      { src: dp23, alt: "Centrum Siły — drugie piętro 23" },
      { src: dp24, alt: "Centrum Siły — drugie piętro 24" },
      { src: dp25, alt: "Centrum Siły — drugie piętro 25" },
      { src: dp26, alt: "Centrum Siły — drugie piętro 26" },
      { src: dp27, alt: "Centrum Siły — drugie piętro 27" },
      { src: dp28, alt: "Centrum Siły — drugie piętro 28" },
      { src: dp29, alt: "Centrum Siły — drugie piętro 29" },
      { src: dp30, alt: "Centrum Siły — drugie piętro 30" },
      { src: dp31, alt: "Centrum Siły — drugie piętro 31" },
      { src: dp32, alt: "Centrum Siły — drugie piętro 32" },
      { src: dp33, alt: "Centrum Siły — drugie piętro 33" },
      { src: dp34, alt: "Centrum Siły — drugie piętro 34" },
      { src: dp35, alt: "Centrum Siły — drugie piętro 35" },
    ],
  },
  {
    key: "other",
    label: "Szatnie & Wejście",
    sublabel: "Szatnie, wejście i zewnątrz",
    description:
      "Siłownia zapewnia komfortowe szatnie damskie i męskie wyposażone w zamykane na kłódkę szafki, w pełni wyposażone łazienki oraz prysznice — wszystko, czego potrzebujesz po intensywnym treningu. Wejście do siłowni jest dostępne całą dobę przez 24 godziny na dobę, 7 dni w tygodniu za pomocą systemu elektronicznego.",
    images: [
      { src: sz1, alt: "Centrum Siły — szatnia 1" },
      { src: sz2, alt: "Centrum Siły — szatnia 2" },
      { src: sz3, alt: "Centrum Siły — szatnia 3" },
      { src: sz4, alt: "Centrum Siły — szatnia 4" },
      { src: sz5, alt: "Centrum Siły — szatnia 5" },
      { src: sz6, alt: "Centrum Siły — szatnia 6" },
      { src: sz7, alt: "Centrum Siły — szatnia 7" },
      { src: sz8, alt: "Centrum Siły — szatnia 8" },
      { src: sz9, alt: "Centrum Siły — szatnia 9" },
      { src: wej1, alt: "Centrum Siły — wejście" },
      { src: zew1, alt: "Centrum Siły — zewnątrz 1" },
      { src: zew2, alt: "Centrum Siły — zewnątrz 2" },
      { src: zew3, alt: "Centrum Siły — szyld Centrum Siły 24h" },
    ],
  },
];

const MainGallery = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const [activeSection, setActiveSection] = useState<SectionKey>("floor1");

  const currentSection =
    gallerySections.find((s) => s.key === activeSection) ?? gallerySections[0];

  const closeModal = () => setIsModalOpen(false);

  const openModal = (itemPicture: string) => {
    const idx = currentSection.images.findIndex(
      (img) => img.src === itemPicture,
    );
    setCurrentIndex(idx >= 0 ? idx : 0);
    setIsModalOpen(true);
  };

  const goPrev = (e: React.MouseEvent) => {
    e.stopPropagation();
    setCurrentIndex((i) =>
      i === 0 ? currentSection.images.length - 1 : i - 1,
    );
  };

  const goNext = (e: React.MouseEvent) => {
    e.stopPropagation();
    setCurrentIndex((i) =>
      i === currentSection.images.length - 1 ? 0 : i + 1,
    );
  };

  const currentPicture = currentSection.images[currentIndex];

  return (
    <div className="mainGalleryWrapper">
      <Modal
        isOpen={isModalOpen}
        className={"galleryModalContainer"}
        overlayClassName="galleryModalOverlay"
        onRequestClose={closeModal}
        onAfterOpen={() => {
          document.body.style.overflow = "hidden";
        }}
        onAfterClose={() => {
          document.body.style.overflow = "";
        }}
        ariaHideApp={false}
        contentLabel="Podgląd zdjęcia z galerii">
        {isModalOpen && currentPicture && (
          <div className="galleryModalInner">
            <button
              className="galleryAdditionalExit"
              onClick={closeModal}
              aria-label="Zamknij">
              ✕
            </button>
            <button
              className="galleryNavArrow galleryNavArrowLeft"
              onClick={goPrev}
              aria-label="Poprzednie zdjęcie">
              &#8249;
            </button>
            <img
              src={currentPicture.src}
              loading="lazy"
              className="galleryBigPicture"
              alt={currentPicture.alt}
              onClick={closeModal}
            />
            <button
              className="galleryNavArrow galleryNavArrowRight"
              onClick={goNext}
              aria-label="Następne zdjęcie">
              &#8250;
            </button>
            <div className="galleryModalCounter">
              {currentIndex + 1} / {currentSection.images.length}
            </div>
          </div>
        )}
      </Modal>

      {/* ── Section Navigation ── */}
      <div className="galleryNavHeader">
        <div className="galleryNavTitle">Galeria</div>
        <nav className="galleryNavTabs" aria-label="Sekcje galerii">
          {gallerySections.map((section) => (
            <button
              key={section.key}
              className={`galleryNavTab ${
                activeSection === section.key ? "galleryNavTabActive" : ""
              }`}
              onClick={() => setActiveSection(section.key)}
              aria-current={activeSection === section.key ? "true" : undefined}>
              <span className="galleryNavTabLabel">{section.label}</span>
              <span className="galleryNavTabSub">{section.sublabel}</span>
            </button>
          ))}
        </nav>
      </div>

      {/* ── Section Description ── */}
      <div className="gallerySectionInfo">
        <div className="gallerySectionTitle">{currentSection.label}</div>
        <p className="gallerySectionDesc">{currentSection.description}</p>
        <div className="gallerySectionCount">
          {currentSection.images.length} zdjęć
        </div>
      </div>

      {/* ── Image Grid ── */}
      <div className="mainGalleryGrid">
        {currentSection.images.map((img, idx) => (
          <GalleryImage
            key={`${activeSection}-${idx}`}
            image={img.src}
            alt={img.alt}
            openModal={() => openModal(img.src)}
          />
        ))}
      </div>
    </div>
  );
};

export default MainGallery;
